import { render } from "./RemoteDataSubTab.vue?vue&type=template&id=d03c1746&scoped=true"
import script from "./RemoteDataSubTab.vue?vue&type=script&lang=js"
export * from "./RemoteDataSubTab.vue?vue&type=script&lang=js"

import "./RemoteDataSubTab.vue?vue&type=style&index=0&id=d03c1746&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d03c1746"]])

export default __exports__